import { render, staticRenderFns } from "./CircleUnsoundsIcon.vue?vue&type=template&id=68c615c7&"
import script from "./CircleUnsoundsIcon.vue?vue&type=script&lang=js&"
export * from "./CircleUnsoundsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports